/**
 * The Morrow logo mark (the "M" glyph), inlined as an SVG so it stays crisp and
 * inherits `currentColor`. Path data is the official master geometry
 * (`public/01_Master/morrow-mark-warm-white.svg`) with the transparent padding
 * cropped to a tight viewBox — proportions unchanged.
 */
export function Mark({ className = 'h-5 w-auto' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 165 159"
      fill="currentColor"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d="M165 0 162 0 93 67 94 159 101 157 158 120 164 112Z" />
      <path d="M1 0 0 108 4 116 9 121 69 159 73 159 74 68 4 0Z" />
    </svg>
  );
}
